<template>
  <v-select
    v-if="combinedItems.length"
    v-model="internalValue"
    :items="combinedItems"
    item-title="title"
    return-object
    hide-details
    variant="solo"
    density="compact"
    placeholder="Selecteer een collectie of relatie"
    menu-icon="fal fa-chevron-down"
    :menu-props="{ class: 'kyano-menu ui-menu' }"
    :rules="rules"
    :required="required"
    class="ui-select"
    @update:modelValue="onUpdate"
  >
    <template #item="{ props, item }">
      <ui-list-item
        v-bind="props"
        :icon="item.raw.id === 2 ? 'person' : item.raw.icon || 'list'"
        :title="item.title"
        class="my-1"
      />
    </template>
    <template #selection="{ item }">
      <ui-list-item
        :icon="item.raw.id === 2 ? 'person' : item.raw.icon || 'list'"
        :title="item.title"
        class="my-1"
      />
    </template>
  </v-select>
  <!-- <pre>
  {{ internalValue }}
</pre
  > -->
</template>

<script>
  import { useAppStore } from "@/stores/appStore";

  export default {
    name: "CollectionSelect",
    props: {
      modelValue: [Object, String, Number],
      collections: {
        type: Array,
        default: () => [],
      },
      required: Boolean,
      rules: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      internalValue: {
        get() {
          return this.modelValue;
        },
        set(val) {
          this.$emit("update:modelValue", val);
        },
      },
      appStore() {
        return useAppStore();
      },
      activePage() {
        return this.appStore.active.page;
      },

      /**
       * Alle relation fields uit alle collecties + ALLE user fields (niet alleen relations)
       */
      relationFieldsList() {
        const relationFields = [];
        // Relations van de actieve collectie
        const raw = this.activePage.collection;
        if (raw) {
          const col = this.collections.find((c) => String(c.id) === raw);
          const name = col?.name || "";

          relationFields.push(
            ...(this.appStore.fields || [])
              .filter(
                (f) => f.field_type === "relation" && String(f.collection_id) === raw
              )
              .map((f) => ({
                ...f,
                title: `${name} — ${f.label}`,
                collection_id: `${raw}`,
                icon: "waypoints",
              }))
          );
        }

        // Alleen RELATION fields van users (collection_id == 2)
        const userCollection = this.collections.find(
          (c) => c.id === 2 || c.collection_id === 2
        );
        if (userCollection) {
          // Alleen relation-fields van users
          const userFields =
            this.appStore.all_fields
              .find((f) => f.collection.id == 2)
              ?.fields.filter((f) => f.field_type === "relation") || [];
          relationFields.push(
            ...userFields.map((f) => ({
              ...f,
              title: `Gebruiker — ${f.label}`,
              icon: "person",
            }))
          );
        }

        return relationFields;
      },

      combinedItems() {
        // Basis collecties
        const cols = this.collections.map((c) => ({
          ...c,
          collection_id: c.collection_id ?? c.id,
          title: c.name,
          icon: c.icon,
        }));
        // Voeg relations toe
        return [...cols, ...this.relationFieldsList];
      },
    },
    methods: {
      onUpdate(val) {
        // Relation field gekozen
        if (val?.field_type === "relation" && val?.meta_data?.relation_meta) {
          const relMeta = val.meta_data.relation_meta;
          const isUserTable = val.table_name === "users";

          // Bepaal welke collectie we moeten laden:
          // - als users, altijd id = 2
          // - anders de relation_table uit metadata
          const relationCollectionId = isUserTable ? 2 : relMeta.relation_table;

          // Het veld in de gerelateerde collectie
          const relationField = relMeta.relation_field;

          // Fetch de velden van die collectie
          this.appStore.getFields(relationCollectionId);

          // Emit payload met id=2 voor users, anders de echte
          this.$emit("update:modelValue", {
            id: relationCollectionId,
            field: relationField,
            title: val.label || val.field, // of val.label / val.title
            field_meta: val,
          });
          this.$emit("change", {
            id: relationCollectionId,
            field: relationField,
            title: val.label || val.field,
            field_meta: val,
          });
          return;
        }

        // Niet-relation: gewoon de opgegeven collectie
        this.appStore.getFields(val.id);
        this.$emit("update:modelValue", val);
        this.$emit("change", val);
      },
    },
  };
</script>
